import { writable, derived } from 'svelte/store';
import { userSettings, updateSetting } from './userSettingsStore';

// Create a derived store that gets breadcrumb visibility from user settings
export const isHeaderVisible = derived(userSettings, ($userSettings) => {
  return $userSettings.showBreadcrumbs !== undefined ? $userSettings.showBreadcrumbs : true;
});

// Create a derived store that gets compact mode visibility from user settings
export const isCompactMode = derived(userSettings, ($userSettings) => {
  return $userSettings.showBreadcrumbs !== undefined ? !$userSettings.showBreadcrumbs : true;
});

// Create a derived store that gets sidebar collapsed state from user settings
export const sidebarCollapsed = derived(userSettings, ($userSettings) => {
  return $userSettings.sidebarCollapsed !== undefined ? $userSettings.sidebarCollapsed : false;
});

// Function to toggle breadcrumb visibility
export function toggleBreadcrumbs() {
  const currentVisibility = get(isHeaderVisible);
  updateSetting('showBreadcrumbs', !currentVisibility);
}

// Function to toggle sidebar collapsed state
export function toggleSidebar() {
  const currentState = get(sidebarCollapsed);
  updateSetting('sidebarCollapsed', !currentState);
}

// Helper function to get current value from store
function get(store) {
  let value;
  store.subscribe(v => value = v)();
  return value;
} 